<template>
  <div>
    <b-row>
      <b-col lg="2" />
      <b-col lg="8">
        <b-overlay
          id="overlay-background"
          variant="dark"
          opacity="0.85"
          blur="2px"
          rounded="sm"
          :show="loader === true"
          spinner-variant="primary"
          spinner-small
        >
          <b-card>
            <translation-edit-view
              v-if="loader === false"
              class="mt-2 pt-75"
              :user-data="userData"
            />
          </b-card>
        </b-overlay>
      </b-col>
      <b-col lg="2" />
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BRow, BCol,
} from 'bootstrap-vue'
import { ref/* , onUnmounted */ } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import TranslationEditView from './TranslationEditView.vue'
import translationsStoreModule from '../translationsStoreModule'

export default {
  components: {
    BCard,
    BOverlay,
    TranslationEditView,
    BRow,
    BCol,
  },
  data() {
    return {
      loader: true,
      userData: ref(null),
    }
  },
  created() {
    // const userData = ref(null)
    const USER_APP_STORE_MODULE_NAME = 'translations'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, translationsStoreModule)

    store.dispatch('translations/fetchTranslation', { id: router.currentRoute.params.id })
      .then(response => {
        this.userData = response.data.data
        this.loader = false
        console.log('then', this.userData)
      })
      .catch(error => {
        if (error.response.status === 404) {
          this.userData = undefined
        }
      })
  },
}
</script>
<style lang="scss">
.spinner-border{
  width: 2rem;
  height: 2rem;
}
</style>
